import React, { Component } from 'react';
import * as TrilhaRequest from '../../../requests/trilha.request';
import * as SimuladoRequest from '../../../requests/simulado.request';
import Loading from '../../Loading';
import { STATUS_SIMULADO } from '../../../const';
import VisualizarCorrecao from '../questoes/VisualizarCorrecao';
//import { duration } from 'moment';
import ListaEstudos from './ListaEstudos';
import { Subscribe } from 'unstated'
import UserContainer from '../../../containers/user.container'
import FormatDate from '../../../utility/FormatDate';

class TrilhaConteudo extends Component {

    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            loadingGeral: false,
            showEmptyState: false,
            showEmptyStateCorrecao: true,
            periodoAtual: 1,
            periodos: [
                // { numPeriodo: 1, lock: false },
                // { numPeriodo: 2, lock: true },
                // { numPeriodo: 3, lock: true }
            ],
            simuladoAtual: 0,
            simuladoAtualTrilha: false,
        }

        this.onClickTabPeriodo = this.onClickTabPeriodo.bind(this);
        this.onClickSimulado = this.onClickSimulado.bind(this);
        this.onClickTrilha = this.onClickTrilha.bind(this);
        this.onClickAbrirSimuladoAtual = this.onClickAbrirSimuladoAtual.bind(this);
    }

    async componentDidMount() {
        await this.props.userContainer.userProfile()

        this._isMounted = true;

        // //Exibindo o loading
        this.setState({ loadingGeral: true });

        // Atualiza situacao do simulado
        await SimuladoRequest.setSituacaoSimulado();

        // Atualiza notas TRI do aluno
        await SimuladoRequest.setNotasTri();

        //Buscando as informações da trilha
        var trilhaResponse = await TrilhaRequest.getTrilha();
        //console.log(trilhaResponse);

        if (this._isMounted) {
            //Se não tem informação, exibe o emptyState
            if (!trilhaResponse || trilhaResponse.length === 0) {
                this.setState({ loadingGeral: false, showEmptyState: true });
                return;
            }

            this.popularTrilha(trilhaResponse);

            //Esconde o loading
            this.setState({ loadingGeral: false });
        }

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    popularTrilha(trilhaResponse) {

        var periodos = [];
        var periodoAtual = 1;
        var simuladoAtual = 0;

        var group = {};
        for (let index = 0; index < trilhaResponse.length; index++) {
            const element = trilhaResponse[index];
            // console.log('element ',element)

            var periodo = group[element.idPeriodSchoolGrade];

            if (!periodo) {
                periodo = {
                    id: element.idPeriodSchoolGrade,
                    numPeriodo: element.nuPeriod,
                    descricaoPeriodo: element.txPeriodPracticeTest,
                    lock: !element.PeriodEnabled,
                    atual: element.PeriodActive,
                    simulados: []
                };
                group[element.idPeriodSchoolGrade] = periodo;
                if (element.PeriodActive) {
                    periodoAtual = element.nuPeriod
                }
                if (element.inActivePeriodPracticetest) {
                    simuladoAtual = index;
                }

                periodos.push(periodo);
            }
            // console.log('simulado atual ', simuladoAtual)
            //Adiciona o simulado no periodo
            var simulado = {
                id: element.idPeriodPracticeTest,
                tipo: element.idPracticeTestType,
                descricao: element.txPracticeTestType,
                cssClass: element.txCSSImageLearningTrack,
                lock: element.inLockedPracticeTest,
                lockTrilha: element.inLockedLearningTrack,
                idExam: element.idExam,
                dtStartEvent: element.dtStartEvent,
                dtEndEvent: element.dtEndEvent,
                status: element.idExamTakenStatus || 1,
                canStart: element.canStart,
                hasExpired: element.hasExpired,
                inContinueExam: element.inContinueExam
            };
            periodo.simulados.push(simulado);
        }

        var item = this.getIndexItemAtual();
        this.setState({
            periodos: periodos,
            periodoAtual: periodoAtual,
            simuladoAtual: simuladoAtual,
            simuladoAtualTrilha: item.trilha
        });
    }

    getSimuladosPeriodoAtual() {
        var periodo = (this.state.periodos || [])[this.state.periodoAtual - 1];
        var itens = (periodo && periodo.simulados) || [];
        return itens;
    }

    getSimuladoAtual() {
        var simulado = this.getSimuladosPeriodoAtual()[this.state.simuladoAtual];
        // console.log('simulado atual ', simulado)

        return simulado || {};
    }

    getIconFromType(type, description) {
        if (type === 1) { return <img src="/images/ico-simu-diag.svg" alt={description} style={{ width: "70%" }} /> }
        else if (type === 2) { return <img src="/images/ico-simu-dev.svg" alt={description} style={{ width: "80%" }} /> }
        else if (type === 3) { return <img src="/images/ico-simu-evo.svg" alt={description} style={{ width: "80%" }} /> }
    }

    getIconTrilhaFromType(type) {
        if (type === 1) { return <img src="/images/ico-trilha1.svg" alt="1ª Trilha" style={{ width: "100%" }} /> }
        else if (type === 2) { return <img src="/images/ico-trilha2.svg" alt="2ª Trilha" style={{ width: "100%" }} /> }
        else if (type === 3) { return <img src="/images/ico-trilha3.svg" alt="3ª Trilha" style={{ width: "100%" }} /> }
    }

    getIndexItemAtual() {

        var idx = 0;
        var trilha = false;

        var simulados = this.getSimuladosPeriodoAtual();

        for (let index = simulados.length - 1; index >= 0; index--) {
            const simulado = simulados[index];

            if (!simulado.lock) {
                idx = index;

                trilha = !simulado.lockTrilha;
                break;
            }
        }

        return { idx, trilha };
    }

    getProgressoGeral() {
        var itemAtual = this.getIndexItemAtual();
        var simulados = this.getSimuladosPeriodoAtual();
        // console.log('periodoAtual',this.state.periodoAtual)

        //Quantidade de partes que a barra de progresso terá de acordo com a quantidade de simulados e trilhas
        // console.log(simulados.length);
        var qtd = (simulados.length * 2);

        // *** não haverá outros simulados em 2019 para o 1º período
        if (this.state.periodoAtual === 1) {
            qtd = 4;
        }

        //Quantidade de partes que deve pintar de acordo com o item atual
        var p = (itemAtual.idx * 2);

        //Se for trilha, pinta uma parte a mais
        if (itemAtual.trilha) {
            p += 1
        }

        //Margem inicial padrão
        var m = (1 / qtd) / 2;

        //Calcula a porcentagem da parte pintada em relação ao todo
        var porcentagem = Math.round(((p / qtd) + m) * 100);
        return porcentagem;
    }

    getEmptyStateSemAgendamento() {
        var simulado = this.getSimuladoAtual();

        return <div className="edb-container" style={{ maxWidth: '960px', margin: '0 auto' }}>
            <div className="edb-col"><h1>Onde está meu simulado?</h1></div>
            <div className="edb-container edb-third"><img alt="Cadê o meu simulado" src="images/emptystates/whereis.svg" width="100%" /></div>
            <div className="edb-container edb-twothird">
                Se você está vendo essa tela seu simulado ainda não está marcado.  Peça seu coordenador para agendar.<br /><br />
                A <strong>Adaptativa+</strong> é sua nova ferramenta de aprendizado com foco no Enem e funciona assim:<br /><br />
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>1</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">{simulado.descricao}</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">{simulado.descricao}</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Primeiro você faz uma prova chamada {simulado.descricao}. Ela identificará onde estão suas maiores habilidades e onde você precisa estudar mais.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>2</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Gabarito e resolução em vídeo</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Gabarito e resolução em vídeo</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Ao finalizar o simulado vamos te mostrar o resultado de sua prova com videos explicando a resolução de cada questão.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>3</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Gráficos de acompanhamento</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Gráficos de acompanhamento</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Em seguida, a Adaptativa+ lhe mostrará gráficos sobre seu desempenho. É hora de avaliar onde você precisa dedicar mais estudos.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>4</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Estudos semanais</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Estudos semanais</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Nas semanas seguintes a Adaptativa+ colocará a sua disposição exatamente o que você precisa estudar.</p>
                    </div>

                </div>
                <p>Legal, não é? Essa fórmula se repetirá durante esse ano e você ficará cada vez melhor cada vez mais perto do sucesso no Enem.</p>

            </div>

        </div>
    }
    getEmptyComAgendamento() {
        var simulado = this.getSimuladoAtual();
        var periodo = null;

        if (simulado) {
            // termino = '14:00 de 12/04/2019';
            periodo = FormatDate.formatPeriod(simulado.dtStartEvent, simulado.dtEndEvent)
        }


        return <div className="edb-container" style={{ maxWidth: '960px', margin: '0 auto' }}>
            <div className="edb-col"><h1>Oba! Simulado agendado!</h1></div>
            <div className="edb-container edb-third edb-col"><img alt="Simulado agendado" src="images/emptystates/yupi.svg" width="100%" /></div>
            <div className="edb-container edb-twothird">
                Se prepare. {periodo} você fará o {simulado.descricao.toLowerCase()} para iniciar sua jornada de aprendizado pela Adaptativa+.<br /><br />
                É imprescindível você se dedicar nessa etapa que vai avaliar suas habilidades e onde você precisa estudar mais.<br /><br />
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>1</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">{simulado.descricao}</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">{simulado.descricao}</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Primeiro você faz uma prova chamada {simulado.descricao}. Ela identificará onde estão suas maiores habilidades e onde você precisa estudar mais.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>2</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Gabarito e resolução em vídeo</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Gabarito e resolução em vídeo</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Ao finalizar o simulado vamos te mostrar o resultado de sua prova com videos explicando a resolução de cada questão.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>3</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Gráficos de acompanhamento</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Gráficos de acompanhamento</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Em seguida, a Adaptativa+ lhe mostrará gráficos sobre seu desempenho. É hora de avaliar onde você precisa dedicar mais estudos.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>4</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Estudos semanais</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Estudos semanais</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Nas semanas seguintes a Adaptativa+ colocará a sua disposição exatamente o que você precisa estudar.</p>
                    </div>

                </div>
                <p>Legal, não é? Essa fórmula se repetirá durante esse ano e você ficará cada vez melhor cada vez mais perto do sucesso no Enem.</p>

            </div>

        </div>
    }

    getEmptyStateIniciar() {
        var simulado = this.getSimuladoAtual();
        var termino = null;

        if (simulado) {
            // termino = '14h00 de 12/04/2019';
            // console.log('simulado.dtEndEvent', simulado.dtEndEvent)
            termino = FormatDate.formatDateTime(simulado.dtEndEvent)
        }

        return <div className="edb-container edb-center" style={{ maxWidth: '960px', margin: '0 auto' }}>
            <div className="edb-container edb-third edb-col"><img alt="Preparar para lançamento" src="/images/emptystates/rocket.svg" width="100%" /></div>
            <div className="edb-container edb-third edb-center">
                <h1>É agora!</h1>
                {termino && <span>Você tem até <strong>{termino}</strong> para terminar seu simulado.<br /></span>}<br />
                <button className="edb-button edb-green edb-center" onClick={this.onClickAbrirSimuladoAtual}>Iniciar simulado</button>

            </div>
            <div className="edb-container edb-third edb-col"></div>

        </div>
    }

    getEmptyStateExpiradoPrazo() {
        return <div className="edb-container" style={{ maxWidth: '960px', margin: '0 auto' }}>
            <div className="edb-col"><h1>Você perdeu o simulado, e agora?</h1></div>
            <div className="edb-container edb-third edb-col"><img alt="Prazo do simulado expirado" src="/images/emptystates/cry.svg" width="100%" /></div>
            <div className="edb-container edb-twothird">

                <div className="edb-row edb-margin-bottom">

                    <div className="edb-col m10" style={{ color: '#bbb' }}>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Simples! Procure seu coordenador e solicite que ele faça reagendamento do seu simulado.</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Simples! Procure seu coordenador e solicite que ele faça reagendamento do seu simulado.</h3>

                    </div>
                </div>
            </div>
        </div>
    }

    getEmptyStateRealizado() {
        var simulado = this.getSimuladoAtual();

        return <div className="edb-container" style={{ maxWidth: '960px', margin: '0 auto' }}>
            <div className="edb-col"><h1>Estamos corrigindo seu simulado!</h1></div>
            <div className="edb-container edb-third edb-col"><img alt="Robô corrigindo simulado" src="/images/emptystates/robots.svg" width="100%" /></div>
            <div className="edb-container edb-twothird">

                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-light-gray edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px', color: '#ccc !important' }}>1</span>
                    </div>

                    <div className="edb-col m10" style={{ color: '#bbb' }}>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small ">{simulado.descricao}</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">{simulado.descricao}</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Primeiro você faz uma prova chamada {simulado.descricao}. Ela identificará onde estão suas maiores habilidades e onde você precisa estudar mais.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>2</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Gabarito e resolução em vídeo</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Gabarito e resolução em vídeo</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Ao finalizar o simulado vamos te mostrar o resultado de sua prova com videos explicando a resolução de cada questão.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>3</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Gráficos de acompanhamento</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Gráficos de acompanhamento</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Em seguida, a Adaptativa+ lhe mostrará gráficos sobre seu desempenho. É hora de avaliar onde você precisa dedicar mais estudos.</p>
                    </div>

                </div>
                <div className="edb-row edb-margin-bottom">
                    <div className="edb-col m2 edb-center">
                        <span className="edb-circle edb-green edb-inline edb-padding-small-top edb-center" style={{ width: '35px', height: '35px' }}>4</span>
                    </div>

                    <div className="edb-col m10">
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-hide-small">Estudos semanais</h3>
                        <h3 className="edb-medium edb-margin-none edb-margin-small-bottom edb-center edb-hide-medium edb-hide-large">Estudos semanais</h3>

                        <p className="edb-small edb-line-height-tiny edb-margin-none">Nas semanas seguintes a Adaptativa+ colocará a sua disposição exatamente o que você precisa estudar.</p>
                    </div>

                </div>

            </div>

        </div>
    }

    onClickSimulado(item, index) {

        //Se o item está bloqueado não faz nada
        if (item.lock) { return; }
        // console.log('item', item, 'index', index, 'this.state.simuladoAtual', this.state.simuladoAtual)
        this.setState({ simuladoAtual: index, simuladoAtualTrilha: false });
    }

    onClickTrilha(item, index) {

        //Se o item está bloqueado não faz nada
        if (item.lockTrilha) { return; }

        this.setState({ simuladoAtual: index, simuladoAtualTrilha: true });
    }

    onClickTabPeriodo(numPeriodo) {
        this.setState({ periodoAtual: numPeriodo, simuladoAtual: 0, simuladoAtualTrilha: false });
    }

    onClickAbrirSimuladoAtual() {
        var simulado = this.getSimuladoAtual();
        if (!simulado) { return; }

        //Navega para a tela do simulado
        window.location.hash = "#/simulado/" + simulado.idExam;
    }

    render() {

        return (<div>

            {this.state.loadingGeral && <Loading />}

            {/* ************* EmptyState ************** */}
            {!this.state.loadingGeral && this.state.showEmptyState && this.getEmptyStateSemAgendamento()}

            {!this.state.loadingGeral && !this.state.showEmptyState && <div>

                {/* *********** Aba períodos ************* */}
                <div className="edb-margin-top">
                    {this.state.periodos.map((item, index) =>
                        <div className="edb-inline" key={'aba-periodo-' + index}>
                            <button className={
                                "edb-btn edb-block adap-trilha-tab-periodo"
                                + (this.state.periodoAtual === item.numPeriodo ? " adap-dark-gray" : "")
                                + (item.lock ? " edb-lock" : "")}
                                disabled={item.lock}
                                onClick={() => this.onClickTabPeriodo(item.numPeriodo)}
                            >{item.numPeriodo}º período</button>
                            {this.state.periodoAtual === item.numPeriodo && <div className="adap-trilha-tab-indicator"></div>}
                        </div>
                    )}
                </div>

                {/* *********** Cabeçalho trilha ************* */}
                <div className="adap-white adap-trilha-cabecalho">

                    <div style={{ minWidth: "700px" }}>

                        <div className="adap-trilha-container-progresso">
                            <div className="adap-trilha-progresso" style={{ width: this.getProgressoGeral() + "%" }}></div>
                            <div className="adap-trilha-progresso" style={{ width: this.getProgressoGeral() + "%" }}></div>
                        </div>

                        <div className="edb-row adap-trilha-container-itens" >

                            {this.getSimuladosPeriodoAtual().map((item, index) =>
                                <React.Fragment key={"itemSimulado-" + index}>
                                    <div className={"edb-col s2 edb-center " +
                                        (this.state.simuladoAtual === index && this.state.simuladoAtualTrilha === false ? " adap-trilha-item-ativo" : "")} >
                                        <div className={"adap-trilha-icone adap-green " + (item.lock ? " edb-lock" : "")}
                                            onClick={() => this.onClickSimulado(item, index)}>
                                            {this.getIconFromType(item.tipo, item.descricao)}
                                        </div>
                                        <div className="edb-small adap-trilha-item-desc" style={{ textTransform: "uppercase" }}>{item.descricao}</div>
                                    </div>

                                    <div className={"edb-col s2 edb-center " +
                                        (this.state.simuladoAtual === index && this.state.simuladoAtualTrilha === true ? " adap-trilha-item-ativo" : "")}>
                                        <div className={"adap-trilha-icone adap-green " + (item.lockTrilha ? " edb-lock" : "")}
                                            onClick={() => this.onClickTrilha(item, index)}>
                                            {this.getIconTrilhaFromType(item.tipo)}
                                        </div>
                                        <div className="edb-small adap-trilha-item-desc">{index + 1}ª TRILHA</div>
                                    </div>
                                </React.Fragment>
                            )}

                        </div>
                    </div>
                </div>

                {/* ************************ Exibindo simulado de acordo com o status ************************* */}
                {this.getSimuladoAtual() && !this.state.simuladoAtualTrilha && <div className="adap-white edb-padding-large">

                    {/* *** Simulado Cancelado para reprocessamento *** */}
                    {this.getSimuladoAtual().status === STATUS_SIMULADO.CANCELADO && <div className="edb-center edb-margin-large-top edb-margin-large-bottom">
                        <i className="fas fa-sad-tear edb-xxlarge"></i>
                        <h4>Este simulado foi cancelado para reprocessamento.</h4>
                        <p>Para mais informações, procure o seu coordenador.</p>
                    </div>}

                    {/* *** Simulado não agendado *** */}
                    {this.getSimuladoAtual().canStart === null && this.getSimuladoAtual().status === STATUS_SIMULADO.AGENDADO && this.getEmptyStateSemAgendamento()}

                    {/* *** Simulado agendado *** */}
                    {this.getSimuladoAtual().canStart === 0 && this.getSimuladoAtual().status === STATUS_SIMULADO.AGENDADO && this.getEmptyComAgendamento()}

                    {/* *** Simulado Disponível *** */}
                    {this.getSimuladoAtual().canStart === 1 && this.getSimuladoAtual().hasExpired === 0 && this.getSimuladoAtual().status === STATUS_SIMULADO.AGENDADO && this.getEmptyStateIniciar()}

                    {/* *** Simulado Em andamento *** */}
                    {this.getSimuladoAtual().canStart === 1 && this.getSimuladoAtual().hasExpired === 1 && this.getSimuladoAtual().status === STATUS_SIMULADO.AGENDADO && this.getEmptyStateExpiradoPrazo()}

                    {/* *** Simulado Em andamento *** */}
                    {/* permite todos continuar depois */}
                    {this.getSimuladoAtual().status === STATUS_SIMULADO.EM_REALIZACAO && /*this.getSimuladoAtual().inContinueExam && */ this.getSimuladoAtual().hasExpired === 0 && <div className="edb-center edb-margin-large-top edb-margin-large-bottom">

                        <h4>Simulado em andamento!</h4>
                        <p>Clique no botão abaixo para continuar seu simulado.</p>
                        <button className="edb-button edb-round adap-green edb-large" onClick={this.onClickAbrirSimuladoAtual} >Continuar simulado</button>

                    </div>}

                    {/* *** Simulado Realizado *** */}
                    {/* permite todos continaur depois */}
                    {(this.getSimuladoAtual().status === STATUS_SIMULADO.REALIZADO || this.getSimuladoAtual().status === STATUS_SIMULADO.CORRIGIDO /* || (this.getSimuladoAtual().status === STATUS_SIMULADO.EM_REALIZACAO && !this.getSimuladoAtual().inContinueExam)*/) && this.getSimuladoAtual().hasExpired === 0 && this.getEmptyStateRealizado()}

                    {/* *** Simulado Corrigido *** */}
                    {(this.getSimuladoAtual().status === STATUS_SIMULADO.REALIZADO || this.getSimuladoAtual().status === STATUS_SIMULADO.CORRIGIDO) && this.getSimuladoAtual().hasExpired === 1 && <VisualizarCorrecao idExam={this.getSimuladoAtual().idExam} />}

                    {/* *** Simulado Anulado *** */}
                    {this.getSimuladoAtual().status === STATUS_SIMULADO.ANULADO && <div className="edb-center edb-margin-large-top edb-margin-large-bottom">
                        <i className="fas fa-sad-tear edb-xxlarge"></i>
                        <h4>Infelizmente este simulado foi anulado.</h4>
                        <p>Para mais informações, procure o seu coordenador.</p>
                    </div>}

                </div>}

                {this.getSimuladoAtual() && this.state.simuladoAtualTrilha === true && <div className="adap-white edb-padding-large">

                    {/* *********** Lista de Conteúdos ************* */}
                    <ListaEstudos userContainer={this.props.userContainer} idPeriodoSimulado={this.getSimuladoAtual().id} dtEndEvent={FormatDate.formatDateTime(this.getSimuladoAtual().dtEndEvent)} />
                </div>}


            </div>}
        </div>);

    }
}
export default (props) => (<Subscribe to={[UserContainer]}>
    {(user) => <TrilhaConteudo {...props} userContainer={user} />}
</Subscribe>);


// export default TrilhaConteudo;